import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { applyHsts, httpsRedirectTarget } from "./lib/https-redirect";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

// Force HTTPS for every visitor on both coffmancovelodging.com and
// www.coffmancovelodging.com, then pin the upgrade with HSTS.
const httpsMiddleware = createMiddleware().server(async ({ next, request }) => {
  const target = httpsRedirectTarget(request);
  if (target) {
    return new Response(null, {
      status: 301,
      headers: {
        location: target,
        "strict-transport-security": "max-age=63072000; includeSubDomains; preload",
      },
    });
  }
  const result = await next();
  const response = (result as { response?: Response }).response;
  if (response) applyHsts(response, request);
  return result;
});

const errorMiddleware = createMiddleware().server(async ({ next, request }) => {
  // /lovable/* routes authenticate themselves (API key / signed webhook / JWT)
  // and must never be redirected or wrapped by app-level handling.
  if (new URL(request.url).pathname.startsWith("/lovable/")) {
    return next();
  }
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [httpsMiddleware, errorMiddleware],
}));
